<template>
  <form @submit.prevent="updateRoleData"
        class="role-info">

    <label class="input-cont input-cont_small" :class="{'error': nameError}">
      <p class="label">
        {{$t('roles.roleNameInfo')}}
      </p>
      <input @blur="checkName"
             @focus="hideName"
             v-model="name">
      <errors v-show="nameError"></errors>
    </label>

    <div class="select-cont select-cont_tags" @click="hideBtn = false">
      <p class="label">
        {{$t('labels.tags')}}
      </p>

      <v-select taggable multiple push-tags
                v-model="tags_diff"
                label="name"
                :options="tags_options"
                :create-option="tag => ({ name: tag })">
      </v-select>
    </div>

    <label @click="hideBtn = false" class="textarea-wrap">
      <p class="label">{{$t('forms.descLb')}}</p>
      <textarea v-model="desc"></textarea>
    </label>
    <button type="submit"
            :disabled="!name || hideBtn"
            v-show="name && !hideBtn"
            :class="{'loading': loading}"
            class="btn-light-blue btn">
      {{$t('btns.save')}}
    </button>
  </form>
</template>

<script>
  import errors from '../../Forms/errors'
  import {mapGetters, mapState, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {toFormData} from "../../../mixins/utils/toFormData";

  export default {
    name: 'roleInfoInfo',
    props: {
      name: {
        type: String
      },
      desc: {
        type: String
      },
      tags: {
        type: Array
      }
    },
    mixins: [tokenAndRoute, toFormData],
    components: {
      errors
    },
    data() {
      return {
        nameError: false,
        hideBtn: true,
        loading: false,
        tags_diff: [],
        tags_options: this.allRolesTags
      }
    },
    computed: {
      ...mapState({
        allRolesTags: state => state.roles.allRolesTags
      }),
      ...mapGetters({
        activeRole: 'roles/activeRole'
      })
    },
    methods: {
      ...mapActions({
        updateRole: 'roles/updateRole',
        createRoleTag: 'roles/createRoleTag',
        unsetRoleTag: 'roles/unsetRoleTag',
        getProjects: 'projects/getProjects',
      }),
      checkName() {
        if (!this.name) {
          this.nameError = true
        } else {
          this.nameError = false
        }
      },
      hideName() {
        this.nameError = false;
        this.hideBtn = false
      },
      async updateRoleData() {
        this.loading = true;

        let added_tags = '';

        for(let x = 0; x < this.tags_diff.length; x++) {
          let is_added = true;

          for(let i = 0; i < this.tags.length; i++) {
            if(this.tags[i].id == this.tags_diff[x].id) {
              is_added = false;

              break;
            }
          }

          if(is_added) {
            if(added_tags != '') {
              added_tags += ',';
            }

            added_tags += this.tags_diff[x].name;
          }
        }

        if(added_tags) {
          await this.createRoleTag({tags: added_tags, object_type: 'role', object_id: this.$route.params.id}).then(res => {
          });
        }

        let unseted_tags = '';

        for(let x = 0; x < this.tags.length; x++) {
          let is_delete = true;

          for(let i = 0; i < this.tags_diff.length; i++) {
            if(this.tags[x].id == this.tags_diff[i].id) {
              is_delete = false;

              break;
            }
          }

          if(is_delete) {
            if(unseted_tags != '') {
              unseted_tags += ',';
            }

            unseted_tags += this.tags[x].name;
          }
        }

        if(unseted_tags) {
          await this.unsetRoleTag({tags: unseted_tags, object_type: 'role', object_id: this.$route.params.id}).then(res => {
          });
        }

        let data = {
          group_id: this.activeRole.parent || 0,
          //access_token: this.token,
          id: this.activeRole.id,
          name: this.name,
          description: this.desc
        };

        let formData = this.toFormData(data);

        await this.updateRole({token: this.token, data: formData, reloadData: false}).then(() => {
          this.getProjects()
          this.$emit('reload')
        });
        this.loading = false;
        this.hideBtn = true
      }
    },
    watch: {
      tags(val) {
        this.tags_diff = this.tags;
      }
    },
    mounted() {
      if(this.tags) {
        this.tags_diff = this.tags;
      }

      if(this.allRolesTags) {
        this.tags_options = this.allRolesTags;
      }
    }
  }
</script>

<style lang="scss" scoped>
.role-info .btn-light-blue {
  width: 100%;
  margin-top: 20px;
}

.role-info {
  margin-top: 40px;
}

.role-info  .input-cont {
    margin-bottom: 20px;
}
/*.vs__selected-options input {*/
/*  width: 300px!important;*/
/*}*/
</style>
<style lang="scss">
  .vs__selected-options {
    input {
      width: 350px!important;
      color: $darkBlue;
    }
  }
</style>
